module.exports = __webpack_public_path__ + "static/media/astronomer.60940e82.jpg";